import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Select } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { CodePostalDto, PaysDto, UniteMesureDto } from 'src/api/models';
import { ControlPanelStore } from 'src/states/control-panel.store';

@Component({
  selector: 'app-unite-mesure',
  templateUrl: './unite-mesure.component.html',
  styleUrls: ['./unite-mesure.component.css']
})
export class UniteMesureComponent implements OnInit, OnDestroy {
  @Select(ControlPanelStore.unitesMesure$) unitesMesure$: Observable<UniteMesureDto[]>;
  
  @Input('uniteMesureId') public uniteId: number;

  UniteInComponent: UniteMesureDto;

  u: Subscription;
  
  constructor() {}

  ngOnInit() {
    this.u = this.unitesMesure$.subscribe(res => {
      if (res != null) {
        let unite = res.filter(u => u.Id == this.uniteId);
        this.UniteInComponent = unite.length == 1 ? unite[0] : { Identifiant: null };
      }
    });
  }

  ngOnDestroy() {
    this.u?.unsubscribe();
  }
}
